import React from 'react';
import {
    LayoutDashboard,
    ShieldAlert,
    ClipboardCheck,
    Bug,
    Sliders,
    FlaskConical,
    AlertOctagon,
    Zap,
    Search
} from 'lucide-react';

interface AnalystSidebarProps {
    activeView: string;
    onViewChange: (view: string) => void;
    isOpen: boolean;
}

const AnalystSidebar: React.FC<AnalystSidebarProps> = ({ activeView, onViewChange, isOpen }) => {
    const navItems = [
        { id: 'DASHBOARD', label: 'Overview', icon: <LayoutDashboard size={20} /> },
        { id: 'RISK_REGISTER', label: 'Risk Register', icon: <ShieldAlert size={20} /> },
        { id: 'ASSESSMENTS', label: 'Assessments', icon: <ClipboardCheck size={20} /> },
        { id: 'VULNERABILITIES', label: 'Vulnerabilities', icon: <Bug size={20} /> },
        { id: 'CONTROL_REGISTER', label: 'Control Register', icon: <Sliders size={20} /> },
        { id: 'TESTING', label: 'Testing', icon: <FlaskConical size={20} /> },
        { id: 'DEFICIENCIES', label: 'Deficiencies', icon: <AlertOctagon size={20} /> },
        { id: 'EVENTS', label: 'Events (CM)', icon: <Zap size={20} /> },
        { id: 'INVESTIGATIONS', label: 'Investigations', icon: <Search size={20} /> },
    ];

    return (
        <div className={`analyst-sidebar ${isOpen ? 'expanded' : 'collapsed'}`}>
            <nav className="analyst-sidebar-nav">
                {navItems.map((item) => (
                    <button
                        key={item.id}
                        data-testid={`NAV_analyst_sidebar_${item.id}`}
                        onClick={() => onViewChange(item.id)}
                        className={`w-full flex items-center gap-3 px-4 py-3 text-sm font-medium transition-colors ${activeView === item.id
                            ? 'bg-white/20 text-white border-r-4 border-white'
                            : 'text-red-100 hover:bg-white/10 hover:text-white'
                            }`}
                    >
                        {item.icon}
                        {isOpen && <span>{item.label}</span>}
                    </button>
                ))}
            </nav>
        </div>
    );
};

export default AnalystSidebar;
